import { style } from "@vanilla-extract/css";

// All header/positioning styles live as inline style on the <Box as="header">
// in layout.tsx — see that file for the mirror of the prototype's setup.
// Only the back-link gets a class here because it needs a media query.
export const backButton = style({
  display: "flex",
  alignItems: "center",
  gap: "var(--cp-spacing-xsmall)",
  font: "var(--cp-text-body-medium)",
  color: "var(--cp-action-color-branded-primary-enabled)",
  textDecoration: "none",
  whiteSpace: "nowrap",
  pointerEvents: "auto",
  // Mobile only — on desktop the in-page back link takes over.
  "@media": {
    "(min-width: 768px)": {
      display: "none",
    },
  },
});
